import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import ScheduledTasks from "./ScheduledTasks";

// Wrapper page that reuses the ScheduledTasks form for editing a specific schedule.
const ScheduleEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initial, setInitial] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    api
      .get(`/scheduled-tasks/${id}`)
      .then(({ data }) => {
        if (mounted) setInitial(data.data);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [id]);

  if (loading) {
    return (
      <main className="page">
        <div className="loading">
          <div className="spinner" />
        </div>
      </main>
    );
  }

  if (!initial) {
    return (
      <main className="page">
        <div className="empty-state">
          <h3>Schedule not found</h3>
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Go back
          </button>
        </div>
      </main>
    );
  }

  // Reuse ScheduledTasks in "create" mode but seed its form + editingId via props
  return <ScheduledTasks mode="create" initialSchedule={initial} />;
};

export default ScheduleEdit;

